import { render, staticRenderFns } from "./center-configuration.vue?vue&type=template&id=029c5d4e&scoped=true"
import script from "./center-configuration.vue?vue&type=script&lang=js"
export * from "./center-configuration.vue?vue&type=script&lang=js"
import style0 from "./center-configuration.vue?vue&type=style&index=0&id=029c5d4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c5d4e",
  null
  
)

export default component.exports